import { Injectable, Output, EventEmitter, Injector } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { IomService } from '../services/iom.service';
import { HttpErrorResponse } from '@angular/common/http/http';
import { IomCreateproposal } from 'src/app/models/iom-createproposal';

@Injectable()
export class SessionService {
	envData: any;
	appConfigService: any;

	constructor(private injector: Injector, private iomservice: IomService) {

	}

	public clear() {
		sessionStorage.clear();
	}

	public getSessionStorageItem(id: string): string {
		return sessionStorage.getItem(id);
	}

	public setSessionStorageItem(id: string, value: string) {
		sessionStorage.setItem(id, value);
	}

	public getProposalDetails(): { Market: { MarketName: string, MarketId: number }[], MarketUnit: { MarketUnitId: number, MarketUnitName: string }[], ClientGroup: { ClientGroupId: number, ClientGroupName: string }[], ProposalDetail: IomCreateproposal[] } {
		let propData = this.getSessionStorageItem('Proposaldetails');
		if (propData == "null" || propData == "" || propData == "undefined" || propData == null) {
			//this.GetProData();       
		}
		return JSON.parse(this.getSessionStorageItem('Proposaldetails'));
	}


	// GetProData() :{Market: {MarketName :string, MarketId:number}[],MarketUnit :{ MarketUnitId:number,MarketUnitName:string}[],ClientGroup :{ClientGroupId:number, ClientGroupName:string}[], ProposalDetail : IomCreateproposal[]} 
	// {
	// 	var y= this.getUserName();

	// 	var data =  this.iomservice.getProp<any>().subscribe(data => {
	// 	console.log(data);
	// 	return data;
	//   }
	// }


	public getUserName(): string {
		this.appConfigService = this.injector.get(AppConfigService);
		var data = this.appConfigService.getEnvironment();
		//this.envData = (data.data.AuthProvider)

		var userName = sessionStorage.getItem("userName");
		//if (this.envData != "FormsAuthProvider") {
		if (userName == "null" || userName == "" || userName == "undefined"
			|| userName == null) {
			//userName = "demo.user";
		}
		// }
		// else {

		// }
		return userName;
	}

	public setUserName(username: string) {
		console.log(username);

		sessionStorage.setItem("loggedInUserName", username); //.split('~')[0]);
		// var accesstoken = sessionStorage.getItem("accesstoken");
		// if(accesstoken == "" || accesstoken == undefined || accesstoken == null)
		// {
		// 	if (username != "") {
		// 		sessionStorage.setItem("accesstoken", username.split('~')[1]);
		// 	}
		// 	else{
		// 		sessionStorage.setItem("accesstoken", "");
		// 	}
		// }
	}


	removeSessionValue(key:string) {
		sessionStorage.removeItem(key);
	}
	public getClientUId(): string {
		return this.getSessionStorageItem("clientUId");
	}
	public setClientUId(clientUId: string) {
		this.setSessionStorageItem("clientUId", clientUId);
	}
	public getE2EUId(): string {
		return this.getSessionStorageItem("e2EUId");
	}
	public setE2EUId(e2EUID: string) {
		this.setSessionStorageItem("e2EUId", e2EUID);
	}
	public getCMSUId(): string {
		return this.getSessionStorageItem("cMSUID");
	}
	public setCMSUId(cMSUID: string) {
		this.setSessionStorageItem("cMSUID", cMSUID);
	}
	public getWSUId(): string {
		return this.getSessionStorageItem("wSUId");
	}
	public setWSUId(wSUID: string) {
		this.setSessionStorageItem("wSUId", wSUID);
	}
	public setSolutionId(solutionId: string) {
		this.setSessionStorageItem("solutionId", solutionId);
	}
	public getSolutionId(): string {
		return this.getSessionStorageItem("solutionId");
	}
	public getUserType(): string {
		return this.getSessionStorageItem("userType");
	}
	public getScroll(): string {
		return this.getSessionStorageItem("Scroll");
	}
	
	public getDeliveryConstructUId(): string {
		var defaultDeliveryConstructUId = this.getSessionStorageItem("defaultDeliveryConstructUId");
		if (defaultDeliveryConstructUId == null || defaultDeliveryConstructUId == "undefined" ||
			defaultDeliveryConstructUId == undefined || defaultDeliveryConstructUId == "null") {
			defaultDeliveryConstructUId = "00000000-0000-0000-0000-000000000000";
		}
		return defaultDeliveryConstructUId;
	}
	public setDeliveryConstructUId(deliveryConstructUId: string) {
		this.setSessionStorageItem("defaultDeliveryConstructUId", deliveryConstructUId);
	}
	public setDeliveryConstructName(deliveryConstructName: string) {
		if (deliveryConstructName == null || deliveryConstructName == undefined || deliveryConstructName.length == 0) {
			deliveryConstructName = "";
		}
		this.setSessionStorageItem("deliveryConstructName", deliveryConstructName);
	}
	public getDeliveryConstructName(): string {
		var deliveryConstructName = this.getSessionStorageItem("deliveryConstructName");
		if (deliveryConstructName == null || deliveryConstructName == undefined || deliveryConstructName.length == 0) {
			deliveryConstructName = "";
		}
		return deliveryConstructName;
	}	
	public setParentDeliveryConstructName(deliveryParentConstructName: string) {
		if (deliveryParentConstructName == null || deliveryParentConstructName == undefined || deliveryParentConstructName.length == 0) {
			deliveryParentConstructName = "";
		}
		this.setSessionStorageItem("deliveryParentConstructName", deliveryParentConstructName);
	}
	public getParentDeliveryConstructName(): string {
		var deliveryParentConstructName = this.getSessionStorageItem("deliveryParentConstructName");
		if (deliveryParentConstructName == null || deliveryParentConstructName == undefined || deliveryParentConstructName.length == 0) {
			deliveryParentConstructName = "";
		}
		return deliveryParentConstructName;
	}
	public setE2EDeliveryConstructName(E2EConstructName: string) {
		if (E2EConstructName == null || E2EConstructName == undefined || E2EConstructName.length == 0) {
			E2EConstructName = "";
		}
		this.setSessionStorageItem("e2eDeliveryConstructName", E2EConstructName);
	}
	public getE2EDeliveryConstructName(): string {
		var E2EConstructName = this.getSessionStorageItem("e2eDeliveryConstructName");
		if (E2EConstructName == null || E2EConstructName == undefined || E2EConstructName.length == 0) {
			E2EConstructName = "";
		}
		return E2EConstructName;
	}
	public setClientName(clientName: string) {
		if (clientName == null || clientName == undefined || clientName.length == 0 || clientName == "Unknown") {
			clientName = "";
		}
		this.setSessionStorageItem("clientName", clientName);
	}
	public getClientName(): string {
		var clientName = this.getSessionStorageItem("clientName");
		if (clientName == null || clientName == undefined || clientName.length == 0) {
			clientName = "";
		}
		return clientName;
	}	
} 
